import React, { useEffect } from "react";

import { useFormikContext } from "formik";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";

import { Divider, Flex, Grid, GridItem, Text } from "@chakra-ui/react";

import { Group } from "../../Group";
import { CustomInputWField } from "../../../../../components/CustomInputWField";
import CustomDropzone from "../../../../../components/CustomDropzone";
import { RadioOptions } from "../../RadioOptions";
import { CustomDatepickerWField } from "../../../../../components/CustomDatepickerWField";

export const PossuiCTPS = ({ idAnexo, scrollToField }) => {
  const { setFieldValue, values, errors, touched } = useFormikContext();

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  return (
    <Group
      border={idAnexo === "5" ? "3px solid #4299E199" : ""}
      scrollToField={idAnexo === "5" ? scrollToField : null}
    >
      <Text
        mt="5"
        mb="2"
        fontWeight={700}
        fontSize="16px"
        lineHeight="21.6px"
        color="#169499"
      >
        CTPS
      </Text>
      <Divider mb="5" />
      <RadioOptions
        label="Possui CTPS?*"
        fieldName="possuiCtps"
        useYes={true}
        errors={errors}
        touched={touched}
      />
      {values.possuiCtps === "F" && (
        <>
          <Grid
            mt="15px"
            templateColumns="repeat(5, 1fr)"
            gap="25px"
            rowGap="20px"
          >
            <GridItem colSpan={{ base: 3, sm: 3, lg: 2 }}>
              <CustomInputWField
                fieldName="numeroCtps"
                label="Número da CTPS*"
                placeholder="Informe o Número da CTPS"
              />
            </GridItem>
            <GridItem colSpan={{ base: 3, sm: 3, lg: 2 }}>
              <CustomInputWField
                fieldName="serieCtps"
                label="Série*"
                placeholder="Informe a Série"
              />
            </GridItem>
            <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
              <CustomDatepickerWField
                fieldName="dataExpedicaoCtps"
                label="Data da Expedição*"
                placeholder="DD/MM/AAAA"
              />
            </GridItem>
          </Grid>
          <Grid mt="25px" templateColumns="repeat(4, 1fr)" gap="25px">
            <GridItem colSpan={{ base: 2, sm: 2, lg: 1 }}>
              <Flex>
                <CustomDropzone
                  whiteSpace={true}
                  formProps={{ setFieldValue }}
                  title="Anexar CTPS"
                  fieldName="ctps"
                  height="42px"
                  width={"216px"}
                />
              </Flex>
            </GridItem>
          </Grid>
        </>
      )}
    </Group>
  );
};
